__turbopack_context__.v({
  "anchorRule": "CardSwipe-module-scss-module__EanBjG__anchorRule",
  "cardSwipe": "CardSwipe-module-scss-module__EanBjG__cardSwipe",
  "cow": "CardSwipe-module-scss-module__EanBjG__cow",
  "dirNext": "CardSwipe-module-scss-module__EanBjG__dirNext",
  "eyebrow": "CardSwipe-module-scss-module__EanBjG__eyebrow",
  "fade-in": "CardSwipe-module-scss-module__EanBjG__fade-in",
  "heart": "CardSwipe-module-scss-module__EanBjG__heart",
  "icon": "CardSwipe-module-scss-module__EanBjG__icon",
  "iconContainer": "CardSwipe-module-scss-module__EanBjG__iconContainer",
  "inner": "CardSwipe-module-scss-module__EanBjG__inner",
  "isActive": "CardSwipe-module-scss-module__EanBjG__isActive",
  "isPrev": "CardSwipe-module-scss-module__EanBjG__isPrev",
  "loaf": "CardSwipe-module-scss-module__EanBjG__loaf",
  "people": "CardSwipe-module-scss-module__EanBjG__people",
  "set-active": "CardSwipe-module-scss-module__EanBjG__set-active",
  "swipe-next": "CardSwipe-module-scss-module__EanBjG__swipe-next",
  "swipe-prev": "CardSwipe-module-scss-module__EanBjG__swipe-prev",
  "swiper": "CardSwipe-module-scss-module__EanBjG__swiper",
  "treeRule": "CardSwipe-module-scss-module__EanBjG__treeRule",
  "trophy": "CardSwipe-module-scss-module__EanBjG__trophy",
});
